module.exports = __webpack_public_path__ + "img/1.f01bb67d.jpg";